import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { useCombinedStore } from "../store";
import Modal from "react-modal";
import MessageBox from "./MessageBox";
import api from "../services/api.service";
import * as Styles from "../styles/AccountBalance.Modal.styles";
import alfredoIcon from "../assets/alfredo-icon.svg";

interface AccountBalanceModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
}

const AccountBalanceModal: React.FC<AccountBalanceModalProps> = ({
  isOpen,
  onRequestClose,
}) => {
  const {
    setSubsidiaryDataZustand,
    subsidiaryDataZustand,
    setOrderDataZustand,
    orderDataZustand,
    setMessageZustand,
    authUserZustand,
  } = useCombinedStore((state) => {
    return {
      setSubsidiaryDataZustand: state.setSubsidiaryDataZustand,
      subsidiaryDataZustand: state.subsidiaryDataZustand,
      setOrderDataZustand: state.setOrderDataZustand,
      orderDataZustand: state.orderDataZustand,
      setMessageZustand: state.setMessageZustand,
      authUserZustand: state.authUserZustand,
    };
  });
  const [customerPhoneFilter, setCustomerPhoneFilter] =
    useState<string>("");
  const [CustomerNameFilter, setCustomerNameFilter] = useState<string>("");
  const modalWrapperRef = useRef<HTMLDivElement>(null);

  const [selectedRow, setSelectedRow] = useState<{
    customerUuid: string;
    customerOrigin: string;
    customerName: string;
    customerPhone: string;
  }>({
    customerUuid: "",
    customerOrigin: "",
    customerName: "",
    customerPhone: "",
  });
  const customersInfo = subsidiaryDataZustand.subsidiaryInfo.find(
    (info: any) => info.subsidiaryInfoType === 1
  );
  let customers = [];
  if (customersInfo) {
    try {
      const subsidiaryInfoValue = customersInfo.subsidiaryInfoValue;
      customers = typeof subsidiaryInfoValue === "string"
        ? JSON.parse(subsidiaryInfoValue)?.Customers
        : subsidiaryInfoValue?.Customers;
    } catch (error) {
      console.error("Error processing customersInfo.subsidiaryInfoValue:", error);
    }
  }
  const filteredRows = customers?.filter(
    (customer: any) =>
      customer.customerName
        .toLowerCase()
        .includes(CustomerNameFilter.toLowerCase()) &&
      customer.customerPhone
        .toString()
        .includes(customerPhoneFilter.toLowerCase())
  );

  if (filteredRows?.length > 0 && selectedRow.customerName === "") {
    setSelectedRow({
      customerUuid: filteredRows[0].customerUuid,
      customerOrigin: filteredRows[0].customerOrigin,
      customerName: filteredRows[0].customerName,
      customerPhone: filteredRows[0].customerPhone,
    });
  }
  const handleCheckboxChange = (
    customerUuid: string,
    customerOrigin: string,
    customerName: string,
    customerPhone: string,
  ) => {
    setSelectedRow({
      customerUuid,
      customerOrigin,
      customerName,
      customerPhone,
    });
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      handleSubmit();
    }
  };

  const handleSubmit = async () => {
    if (selectedRow.customerUuid === "") {
      setMessageZustand(
        `Selecione um cliente para continuar.`,
        `error`
      );
      return;
    }
    try {
      await api.post(`addOrderPayment/${orderDataZustand.orderUuid}/${selectedRow.customerUuid}`, {
        value: Number(orderDataZustand.totals?.total?.replace(",", ".")) ?? 0,
      });
    } catch (error: any) {
      if (error.message === "Network Error") {
        setMessageZustand(
          `Erro ao registrar pagamento, entre em contato com os administradores do Alfredo da sua unidade.`,
          `error`
        );
      } else {
        setMessageZustand(
          `Erro ao registrar pagamento: ${error.message}`,
          `error`
        );
      }
    }
    onRequestClose();
  };

  const handleKeyDown = async (
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    if (event.key === "Enter") {
      await handleSubmit();
    }
  }
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => onRequestClose()}
      style={Styles.customStyles}
      contentLabel="Main Modal"
      ariaHideApp={false}
    >
      <MessageBox />
      <Styles.ModalWrapper
        tabIndex={-1}
        ref={modalWrapperRef}
        onKeyDown={handleKeyDown}
      >
        <Styles.CloseButton onClick={() => onRequestClose()}>
          &times;
        </Styles.CloseButton>
        <Styles.ModalContent>
          <Styles.ModalHeader
            color={
              subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                .buttonsColor
            }
          >
            <Styles.Logo src={alfredoIcon} alt="Alfredo Web OPS" />
            <Styles.ModalTitle>Conta Corrente de Clientes</Styles.ModalTitle>
            <Styles.ModalDescription>{`Selecione o cliente que receberá o valor da conta ao seu saldo.`}</Styles.ModalDescription>
          </Styles.ModalHeader>
          <Styles.ModalBody
            color={
              subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                .backgroundColor
            }
          >
            <Styles.RowContainer>
              <Styles.FieldLabel>
                Pesquise pelo Nome do Cliente:
              </Styles.FieldLabel>
              <Styles.FieldContainer>
                <Styles.TextInput
                  color={
                    subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                      .buttonsColor
                  }
                >
                  <input
                    type="text"
                    placeholder=""
                    autoFocus={true}
                    onChange={(e: ChangeEvent<HTMLInputElement>) =>
                      setCustomerNameFilter(e.target.value)
                    }
                    onKeyPress={handleKeyPress}
                  />
                </Styles.TextInput>
              </Styles.FieldContainer>
            </Styles.RowContainer>
            <Styles.RowContainer>
              <Styles.FieldLabel>
                Pesquise pelo Telefone do Cliente:
              </Styles.FieldLabel>
              <Styles.FieldContainer>
                <Styles.TextInput
                  color={
                    subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                      .buttonsColor
                  }
                >
                  <input
                    type="text"
                    placeholder=""
                    value={customerPhoneFilter}
                    onChange={(e: ChangeEvent<HTMLInputElement>) =>
                      setCustomerPhoneFilter(e.target.value)
                    }
                    onKeyPress={handleKeyPress}
                  />
                </Styles.TextInput>
              </Styles.FieldContainer>
            </Styles.RowContainer>
            <Styles.RowContainer>
              <Styles.TableContainer>
                <Styles.CustomerTable>
                  <thead>
                    <tr>
                      <th style={{ width: "10%" }}>Selecionar</th>
                      <th style={{ width: "30%" }}>Telefone do Cliente</th>
                      <th style={{ width: "40%" }}>Nome do Cliente</th>
                      <th style={{ width: "30%" }}>Saldo do Cliente</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredRows?.flatMap((customer: any) => {
                      const rowKey = customer.customerUuid;
                      const selectedRowKey = selectedRow.customerUuid;
                      return (
                        <tr
                          key={rowKey}
                          className={rowKey === selectedRowKey ? "selected" : ""}
                          onClick={() =>
                            handleCheckboxChange(
                              customer.customerUuid,
                              customer.customerOrigin,
                              customer.customerName,
                              customer.customerPhone,
                            )
                          }
                        >
                          <td>
                            <input
                              type="checkbox"
                              checked={rowKey === selectedRowKey}
                              onChange={() => { }}
                            />
                          </td>
                          <td>{customer.customerPhone}</td>
                          <td>{customer.customerName}</td>
                          <td>{(customer.customerBalance ? String(customer.customerBalance).replace(".", ",") : "0,00")}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Styles.CustomerTable>
              </Styles.TableContainer>
            </Styles.RowContainer>
          </Styles.ModalBody>
          <Styles.ModalFooter
            color={
              subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                .buttonsColor
            }
          >
            <div style={{ display: "flex" }}>
              <Styles.Button onClick={() => onRequestClose()}>
                Cancelar
              </Styles.Button>
              <Styles.Button onClick={handleSubmit}>
                Selecionar Cliente
              </Styles.Button>
            </div>
          </Styles.ModalFooter>
        </Styles.ModalContent>
      </Styles.ModalWrapper>
    </Modal>
  );
};

export default AccountBalanceModal;
